import type { Step } from '../types/appointment-booking';

/** IDs estáveis dos alvos do tour de agendamento — reutilizados nos componentes do wizard. */
export const APPOINTMENT_TOUR_TARGET = {
  CREATE: 'FIRST_COMPLETED_APPOINTMENT__CREATE',
  CUSTOMER_CPF: 'FIRST_COMPLETED_APPOINTMENT__CUSTOMER_CPF',
  CUSTOMER_DETAILS: 'FIRST_COMPLETED_APPOINTMENT__CUSTOMER_DETAILS',
  CUSTOMER_CONTINUE: 'FIRST_COMPLETED_APPOINTMENT__CUSTOMER_CONTINUE',
  TYPE: 'FIRST_COMPLETED_APPOINTMENT__TYPE',
  TYPE_CONTINUE: 'FIRST_COMPLETED_APPOINTMENT__TYPE_CONTINUE',
  WORK: 'FIRST_COMPLETED_APPOINTMENT__WORK',
  WORK_CONTINUE: 'FIRST_COMPLETED_APPOINTMENT__WORK_CONTINUE',
  PROFESSIONAL: 'FIRST_COMPLETED_APPOINTMENT__PROFESSIONAL',
  ASSIGN_PROFESSIONAL: 'FIRST_COMPLETED_APPOINTMENT__ASSIGN_PROFESSIONAL',
  ASSIGN_CONTINUE: 'FIRST_COMPLETED_APPOINTMENT__ASSIGN_CONTINUE',
  DATE: 'FIRST_COMPLETED_APPOINTMENT__DATE',
  TIME: 'FIRST_COMPLETED_APPOINTMENT__TIME',
  RECURRENCE: 'FIRST_COMPLETED_APPOINTMENT__RECURRENCE',
  RECURRENCE_CONTINUE: 'FIRST_COMPLETED_APPOINTMENT__RECURRENCE_CONTINUE',
  CONFIRM_REVIEW: 'FIRST_COMPLETED_APPOINTMENT__CONFIRM_REVIEW',
  CONFIRM_SUBMIT: 'FIRST_COMPLETED_APPOINTMENT__CONFIRM_SUBMIT',
  LIST: 'FIRST_COMPLETED_APPOINTMENT__LIST',
} as const;

export type AppointmentTourTargetId =
  (typeof APPOINTMENT_TOUR_TARGET)[keyof typeof APPOINTMENT_TOUR_TARGET];

/** Primeiro alvo de conteúdo ao entrar em cada etapa do wizard. */
export const APPOINTMENT_WIZARD_CONTENT_TARGET_BY_STEP: Partial<
  Record<Step, AppointmentTourTargetId>
> = {
  'customer-data': APPOINTMENT_TOUR_TARGET.CUSTOMER_CPF,
  'appointment-type': APPOINTMENT_TOUR_TARGET.TYPE,
  work: APPOINTMENT_TOUR_TARGET.WORK,
  professional: APPOINTMENT_TOUR_TARGET.PROFESSIONAL,
  'assign-professional-per-work': APPOINTMENT_TOUR_TARGET.ASSIGN_PROFESSIONAL,
  date: APPOINTMENT_TOUR_TARGET.DATE,
  time: APPOINTMENT_TOUR_TARGET.TIME,
  recurrence: APPOINTMENT_TOUR_TARGET.RECURRENCE,
  confirm: APPOINTMENT_TOUR_TARGET.CONFIRM_REVIEW,
};

export const APPOINTMENT_WIZARD_MODAL_TARGET_IDS: readonly AppointmentTourTargetId[] = [
  APPOINTMENT_TOUR_TARGET.CUSTOMER_CPF,
  APPOINTMENT_TOUR_TARGET.CUSTOMER_DETAILS,
  APPOINTMENT_TOUR_TARGET.CUSTOMER_CONTINUE,
  APPOINTMENT_TOUR_TARGET.TYPE,
  APPOINTMENT_TOUR_TARGET.TYPE_CONTINUE,
  APPOINTMENT_TOUR_TARGET.WORK,
  APPOINTMENT_TOUR_TARGET.WORK_CONTINUE,
  APPOINTMENT_TOUR_TARGET.PROFESSIONAL,
  APPOINTMENT_TOUR_TARGET.ASSIGN_PROFESSIONAL,
  APPOINTMENT_TOUR_TARGET.ASSIGN_CONTINUE,
  APPOINTMENT_TOUR_TARGET.DATE,
  APPOINTMENT_TOUR_TARGET.TIME,
  APPOINTMENT_TOUR_TARGET.RECURRENCE,
  APPOINTMENT_TOUR_TARGET.RECURRENCE_CONTINUE,
  APPOINTMENT_TOUR_TARGET.CONFIRM_REVIEW,
  APPOINTMENT_TOUR_TARGET.CONFIRM_SUBMIT,
];

export function getAppointmentWizardTourContentTargetId(
  step: Step
): AppointmentTourTargetId | null {
  return APPOINTMENT_WIZARD_CONTENT_TARGET_BY_STEP[step] ?? null;
}
